module.exports = " <div class=gritcode-wizard> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/wizard/wizard.vue
// module id = 662
// module chunks = 0